import React from 'react';
import { View,  ScrollView, 
        StyleSheet, Animated, TouchableOpacity, 
        Image, Button, Dimensions, Modal, 
        ImageBackground, ActivityIndicator,RefreshControl
     } from 'react-native';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import { WebView } from 'react-native-webview';
import { Surface } from 'react-native-paper';
// import { isIos } from './../Utils';
// import BackHandlerAndroid from './../AndroidBackHandler';
import { connect } from 'react-redux';
// import AdsScreen from './../Ads';
// import Video from 'react-native-video';
import { getLibrarySubjects, clearLibrarySubjectsData } from '../../store/actions';
// import StylesColors from './../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
import { Searchbar } from 'react-native-paper';
import {Text, Styles} from "../../components/UI-Components";
import Header from "./../../components/Header";
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";

// const { width, height } = Dimensions.get("window");
const width = 480;
const _width = window.innerWidth;

// import OfflineHandler from './../OfflineHandler';
// import SubscribeNowForFullScreenDialog from './../fullScreenLoadingComponent';
// import { subscriptionStatusFromLocal } from './../../store/selector';
// import EmptyFullscreen from './../EmptyFullScreen';


const emptySubjectScreen = require('./../../assets/emptyLibrary.png')
const redBoxImage = require('./../../assets/TagRed.png');
const greenBoxImage = require('./../../assets/TagGreen.png')  


const SubjectPriceComponent = ({actualPrice, discountPrice, isFree, isDiscount}) => {
    let price = isFree ? 'Free' : isDiscount ?  '₹' + " "+discountPrice : ' '
    const _isFree = actualPrice < 1 || isFree;
    return(
        <>
        <View 
        style={styles.priceComponent}>
        {/* <ImageBackground
        style={{width: '100%', height: '100%',
          position:'relative',
        }}
         source={_isFree ? greenBoxImage :redBoxImage}
         
        > */}
            <View style={[styles.priceInnerComponent,
                {
                    backgroundColor: _isFree ? '#42BF32' : '#FF7600',
                    justifyContent: _isFree || !isDiscount ? 'flex-end' : 'space-between',
                }
            ]}>
            {/* <Image 
                            source={_isFree ? greenBoxImage : redBoxImage}
                            style={{                         
                                position: 'absolute',
                                width: 100,
                                height: 40,
                                right: -25,
                                top: -3,
                                zIndex: -1                        
                            }}
                        /> */}
                <Text style={styles.priceTitle}>{isFree ? '' : price}</Text>
                <Text style={[isDiscount && !isFree ? styles.strikePrice :styles.priceTitle, {paddingLeft: 10}]}>{isFree ? 'Free' : `₹ ${actualPrice}`}</Text>
            </View>
        {/* </ImageBackground> */}
       </View>
     </>
    )
       
}



class SubjectLibraryBooks extends React.Component {

state = {
    query: '',
    refreshing: false,
}

    // static navigationOptions = ({ navigation }) => {
    //     return {
    //         headerTitle: "SUBJECTS",
    //         headerBackground: 
    //         ( <LinearGradientComponent />),
    //         headerTintColor: StylesColors.headerTintColor,
    //         headerTitleStyle: {
    //             color: StylesColors.headerTextColor,
    //             alignItems:'center',
    //             alignSelf: 'center',
    //             // width: '80%',
    //             textAlign: 'center',
    //             fontWeight: StylesColors.headerTextFontWeight,
    //             textTransform: 'uppercase'
    //         },
    //     }
    // }


    handleSearch= (text) => {
        const formatData = text.toLowerCase();
        
        this.setState({query : text}, ()=>{
          const chooseSubjectData = this.props.librarySubjects.filter( x => {        
              if(x && x.library_subject_name && x.library_subject_name.toLowerCase().includes(formatData)) {
                return x;
              }
          })
        //   console.log(chooseSubjectData.length <=0 )
        //   const _choose = chooseSubjectData.length === 0;
        //   if(_choose){
        //       this.setState({
        //           isSearch: true
        //       })
        //   }
        // if(chooseSubjectData.length <= 0) return
          this.setState({
            _librarySubjects: chooseSubjectData
          })
        })
        
      }


    componentDidMount() {
        const { params={} } = this.props.match
        const{examId=null} = params
        this.props.getLibrarySubjects(examId);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.librarySubjects !== this.props.librarySubjects) {
            if(this.props.librarySubjects) {
                this.setState({
                    _librarySubjects: this.props.librarySubjects,
                    refreshing: false
                })
            }
        }
    }

    componentWillUnmount() {
        this.props.clearLibrarySubjectsData();
    }

    fetchSubjects = () => {
        if(!(this.props.librarySubjects && this.props.librarySubjects.length)) {
            const examId = this.props.navigation.getParam('examId', null);            
            if(examId) {  
                this.setState({
                    examId
                })       
                this.props.getSubjectByExam(examId);
            }
        }
    }
//    refreshLibrary = () => {
//     this.setState({
//         refreshing: true
//     })
//     const examId = this.props.navigation.getParam('examId', null);
//     this.props.getLibrarySubjects(examId);
//     // this.props.clearLibrarySubjectsData()
//    }

   isAdAvailable = (value) => {
    this.setState({
        isAdShow: value
    })
 }
    render() {
        // console.log(this.props.accessToLibrary);

        const { query, _librarySubjects } = this.state;
        return (
            <>
            <Header
            title="Subjects "
            headerRight
            headerRightClick={() => this.props.history.push('/Home')}
            headerLeftClick={() => this.props.history.goBack()}
            backButton={true}
            // headerRightClick={() => alert()}
            />
             <Container maxWidth='lg'>
            <div className='main-component'
            style={{marginTop: 10}}
            >
            
               {
                   this.props.loading && !this.state.refreshing &&  <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                       <LoadingComponent styles={{width: 250, height: 250}}/>
                       </View>
               }

               {
                   this.props.error && <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}><Text>{ typeof this.props.errInfo === 'string' ? this.props.errInfo : 'something went wrong...' }</Text></View>
               } 

               {
                   _librarySubjects && _librarySubjects.length === 0 && !query && 
                   <View style={{width:'100%', height:'100%',}}>

                      {/* <EmptyFullscreen
                       images={emptySubjectScreen}
                       title={'Will Update Soon...'}
                      /> */}
                   </View>
               }

                <ScrollView
            
                >
                {/* {
                   !this.props.loading && !this.props.error && 
                    <Searchbar
                        placeholder="Search Subject"
                        onChangeText={ _query => { this.setState({ query: _query }) }}
                        value={query}
                        style={{margin: 8}}
                        onChangeText = { this.handleSearch}
                        // onFocus={() => {
                        //     this.setState({
                        //         isSearch: true
                        //     })
                        // }}

                    /> 
                } */}
                    
                            <View style={{ flex: 1, flexDirection: _width <= 479  ? 'column'  : 'row', flexWrap: 'wrap', paddingBottom: this.state.isAdShow ? 60 : 0,  marginBottom: 10, marginHorizontal: 23, marginVertical: 10,}}>
                            {
                                _librarySubjects && _librarySubjects.length > 0 && _librarySubjects.map((item, index) => {
                                    const isFree = (item.is_discounted && item.discount_price < 1) || item.actual_price < 1;
                                   
                                    return (
                                        <>
                                            <View key={index} style={{ flexDirection: 'column', flexWrap: 'wrap', position:'relative',  cursor: 'pointer', 
                                             alignSelf: 'center'}}>
                                                <TouchableOpacity
                                                    onPress={() =>
                                                        
                                                        this.props.history.push('/topicLibraryBooks', {
                                                        subjectId: item.id,
                                                        subjectName: item.library_subject_name,
                                                        hasUserPaid: !!item.has_user_paid,
                                                        price: (item.is_discounted && !item.discount_price) ? 0 : item.is_discounted ? item.discount_price : item.actual_price,
                                                        isFree:isFree,
                                                        // accessToLibrary: this.props.accessToLibrary 
                                                    })
                                                    
                                                    }>
                                                    <View style={styles.mainImageView}>
                                                        <View style={{ flex: 2 }}>
                                                            <Image style={styles.ImageView} source={{ uri: item.library_subject_image }} />
                                                        </View>
                                                        {/* <Text style={{fontSize:14,marginLeft:5,justifyContent:'center',alignItems:'center'}}>{item.subject_name}</Text> */}
                                                    </View>
                                                </TouchableOpacity>
                                            
                                            {/* {
                                                 !item.has_user_paid && 
                                                <SubjectPriceComponent
                                                    isFree={(item.is_discounted && item.discount_price < 1) || item.actual_price < 1 }
                                                    actualPrice={item.actual_price}
                                                    discountPrice={item.discount_price}
                                                    isDiscount={item.is_discounted}
                                                    hasUserPaid={!!item.has_user_paid}   
                                                                                 
                                                />
                                            } */}
                                            </View>
                                       </>
                                    )
                                })}
                        </View>
                   
                </ScrollView>
                {/* <AdsScreen screenName={'SubjectLibraryBooks'}
              
               isAdCallBack={() => this.isAdAvailable(true)}
               /> */}
            </div>
            </Container>
            </>
        )
    }
}
const styles = StyleSheet.create({
    mainImageView: {
        height: 140,
        width:_width <= 479  ? Math.floor(_width/2 - 30) : Math.floor(width/2 - 30),
        marginHorizontal: 12,
        // marginBottom,
        elevation: 8,
        marginTop: 5,
        justifyContent:'center',
        alignSelf: 'center'
    },
    ImageView: {
        flex: 1,
        width:_width <= 479  ? Math.floor(_width/2 - 18) : Math.floor(width/2 - 18),
        borderRadius:10,
        marginBottom:5
    },
    container: {
        flex: 1,
        borderWidth: 1,
    },
    closeBtn: {
        fontWeight: '800',
        position: 'absolute',
        top: 50,
        right: 15,
        zIndex: 99999,
        fontSize: 24,
        color: '#fff',
        alignItems: 'center',
    },
    priceComponent: {
        // position:'absolute',
        // width:70,
        // top:10,
        // right:-17,
        // // padding:2,
        // height:40,
        // // fontSize:12,
        
        // justifyContent:'center',
        // alignItems:'center',
        // shadowColor: "#f00",
        // shadowOffset: {
        //     width: 20,
        //     height: 12,
        // },
        // shadowOpacity: 0.58,
        // shadowRadius: 16.00,
        // elevation: 24,
        position: 'absolute',
        // width: 80,
        top: 14,
        right:0,

    },
    priceInnerComponent:{
        minWidth: 60,
        height: 20,
        flexDirection: 'row',       
        alignItems: 'center',
        // paddingHorizontal: 8,      
       zIndex: 1000,
    //    paddingLeft: 5,
    //    marginRight:0
    paddingHorizontal: 6,
       
    //    paddingHorizontal: 4,
    //    borderWidth: 1
    },
    priceTitle: {
        color:'#fff',
        fontSize:12,
        alignSelf:'center',
        // marginTop:-7
    },
    strikePrice:{
        color:'#fff',
        fontSize:12,
        textDecorationLine: 'line-through',
        alignSelf:'center',
        // marginTop:-7
    }
})

const mapStateToProps = state => {
    // const subscriptionStatus = subscriptionStatusFromLocal(state);        
    // const { libraryFullAccess } = subscriptionStatus;
    
    
    return {
        librarySubjects: state.librarySubjects && state.librarySubjects.response && state.librarySubjects.response.library_subjects,
        loading: state.librarySubjects && state.librarySubjects.loading && state.librarySubjects.loading,
        error: state.librarySubjects && state.librarySubjects.error && state.librarySubjects.error,
        errInfo: state.librarySubjects && state.librarySubjects.errInfo && state.librarySubjects.errInfo.data && state.librarySubjects.errInfo.data.message,
        // accessToLibrary: libraryFullAccess,
    }
}

export default connect(mapStateToProps, { getLibrarySubjects, clearLibrarySubjectsData })(SubjectLibraryBooks);